import React, { Component, Fragment, useEffect, useState } from "react";
import AllCaseDetailModal from "../../containers/AllCaseDetails/AllCaseDetailModal";
import { useLocation } from "react-router-dom";
import Backbutton from "../../containers/Common/Backbutton";
import * as utilities from "../../utilities/utils";
import moment from "moment";
import { CASE_STATUS, MODAL_SIZE } from "../../App.config";
import StdAcmdCaseDetailsTableComponent from './StdAcmdCaseDetailsTableComponent';
import AirCaseDetailTableComponent from './AirCaseDetailTableComponent';
import SearchComponent from '../SearchComponent';
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";

const AllCaseDetailsComponent = (props, context) => {

  const [grideView, setGrideView] = useState(true);
  const [state, forceUpdate] = useState(0);
  const [isCCMCase, setIsCCMCase] = useState(true);
  const [isAirCase, setIsAirCase] = useState(true);
  const [isStdCase, setIsStdCase] = useState(true);
  const [isAcmdCase, setIsAcmdCase] = useState(true);
  const [applicantsWithoutMaintenance, setApplicantsWithoutMaintenance] = useState([]);
  const [applicantsWithMaintenance, setApplicantsWithMaintenance] = useState([]);
  const [caseWithMaintenanceCount, setCaseWithMaintenanceCount] = useState(0);
  const [caseWithoutMaintenanceCount, setCaseWithoutMaintenanceCount] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [indexOfRow, setIndexOfRow] = useState(null);

  useEffect(() => {
    if (props.isTableView) {
      setGrideView(false);
    }
  }, [props.isTableView])

  useEffect(() => {
    let casewithmaintenance = [];
    let casewithoutmaintenance = [];
    let casewithmaintenancecount = 0;
    let casewithoutmaintenancecount = 0;
    if (props.applicants) {
      Array.isArray(props.applicants) && props.applicants.length && props.applicants.map((applicant, index) => {
        if (applicant.nextActionId && applicant.nextActionId == 1) {
          casewithmaintenance.push(applicant);
          casewithmaintenancecount = casewithmaintenancecount + 1;
        }
        else {
          casewithoutmaintenance.push(applicant);
          casewithoutmaintenancecount = casewithoutmaintenancecount + 1;
        }
      })
    }
    setApplicantsWithoutMaintenance(casewithoutmaintenance);
    setApplicantsWithMaintenance(casewithmaintenance);
    setCaseWithMaintenanceCount(casewithmaintenancecount);
    setCaseWithoutMaintenanceCount(casewithoutmaintenancecount);
  }, [props.applicants])

  useEffect(() => {
    if (props.isSelectedCase) {
      if (indexOfRow != null) {
        setRow(indexOfRow);
        setIndexOfRow(null);
      }
      else {
        props.openSetModal(
          <AllCaseDetailModal context={props.context} caseDetail={props.selectedCaseDetail} {...props} />,
          MODAL_SIZE.MODAL_LG
        );
      }
      props.resetIsSelectedCase(false);
    }
  }, [props.isSelectedCase]);

  let urllocation = useLocation();

  const onViewChange = (view) => {
    setGrideView(view);
  };

  const setRow = (i) => {
    if (props.applicants[i].otherData) {
      delete props.applicants[i].otherData;
    } else {
      // if (props.applicants[i] && props.selectedCaseDetail)
      //   props.applicants[i] = props.selectedCaseDetail[0];
      if (props.selectedCaseDetail.length > 0) {
        props.applicants[i].otherData = {
          DateCaseOpened: props.selectedCaseDetail[0].dateCaseOpened,
          dateEntered: props.selectedCaseDetail[0].dateEntered,
          PreviousHistory: props.selectedCaseDetail[0].prevHistoryWithOncEmployment,
          CaseNumber: props.selectedCaseDetail[0].caseMgmtID,
          CaseType: props.selectedCaseDetail[0].caseType,
          managedBy: props.selectedCaseDetail[0].managedBy,
          NumberOfOpenDays: props.selectedCaseDetail[0].daysLost,
          NumberOfOpenDaysBussiness: props.selectedCaseDetail[0].daysLostBusiness,
          PhysicianStatement: props.selectedCaseDetail[0].attendingPhyStatRecDate,
          FileStatusInfo: props.selectedCaseDetail[0].fileStatusInformation,
          DateOfMedicalUpdates: props.selectedCaseDetail[0].datesMedicalUpdatesReceived,
          DateEmployerStatementReceived: props.selectedCaseDetail[0].dateEmployerStatementReceived,
          DateOfReductioninBenefits: props.selectedCaseDetail[0].payReductionDate,
          DateCasebecame: props.selectedCaseDetail[0].complexCaseDate,
          FirstDayAbsent: props.selectedCaseDetail[0].firstDayAbsentFromWork,
          CaseStatus: props.selectedCaseDetail[0].caseStatus,
          RestrictionsLimitations: props.selectedCaseDetail[0].restrictions,
          ExpectedRTWDate: props.selectedCaseDetail[0].xRTW,
          RTWDates: null,
          EIDates: props.selectedCaseDetail[0].eiDates,
          STDExpiryDate: props.selectedCaseDetail[0].stdExpiryDate,
          payReductionDate: props.selectedCaseDetail[0].payReductionDate,
          DateClosed: props.selectedCaseDetail[0].dateClosed,
          LastUpdate: props.selectedCaseDetail[0].lastUpdateFileStatusDate,
          lastUpdateFileStatus: props.selectedCaseDetail[0].lastUpdateFileStatus,
          NextAction: props.selectedCaseDetail[0].nextAction,
          NextActionId: props.selectedCaseDetail[0].nextActionId,
          location: props.selectedCaseDetail[0].location,
          dateAIRSubmitted: props.selectedCaseDetail[0].dateAIRSubmitted,
          isAIRCaseOpen: props.selectedCaseDetail[0].isAIRCaseOpen,
          claimTypeAIR: props.selectedCaseDetail[0].claimTypeAIR,
          dateOfIncident: props.selectedCaseDetail[0].dateOfIncident,
          dateLostTimeBegan: props.selectedCaseDetail[0].dateLostTimeBegan,
          dateEmployeeReturnedToWork: props.selectedCaseDetail[0].dateEmployeeReturnedToWork,
          rtwAIRStatus: props.selectedCaseDetail[0].rtwAIRStatus,
          airFileStatus: props.selectedCaseDetail[0].airFileStatus,
          claimStatus: props.selectedCaseDetail[0].airClaimStatus,
          airNextAction: props.selectedCaseDetail[0].nextAction,
          followUpDate: props.selectedCaseDetail[0].followUpDate,
          ltdDate: props.selectedCaseDetail[0].ltdDate,
          isAIR: props.selectedCaseDetail[0].isAIR,
          notes: props.selectedCaseDetail[0].notes,
          hrs: props.selectedCaseDetail[0].hrs,
          seenByMDDate: props.selectedCaseDetail[0].seenByMDDate,
          acmdType: props.selectedCaseDetail[0].acmdType,
          eiDatesText: props.selectedCaseDetail[0].eiDatesText,
          eiDatesFRText: props.selectedCaseDetail[0].eiDatesFRText
        };
      }
    }

    forceUpdate(state + 1);
  }

  const addRow = (i) => {
    if (props.applicants[i].otherData) {
      delete props.applicants[i].otherData;
      forceUpdate(state + 1);
    } else {
      setIndexOfRow(i);
      props.getAllActiveCasesByCaseId(props.applicants[i]);
    }
  };

  const openDetailModal = (caseDetail) => {
    props.getAllActiveCasesByCaseId(caseDetail);
    // props.openSetModal(
    //   <AllCaseDetailModal context={props.context} caseDetail={[caseDetail]} {...props} />,
    //   MODAL_SIZE.MODAL_LG
    // );
  };

  const onStatusChange = (stdstatus, acmdstatus, airstatus, ccmStatus) => {
    let casewithmaintenancecount = 0;
    let casewithoutmaintenancecount = 0;
    setIsStdCase(stdstatus);
    setIsAcmdCase(acmdstatus);
    setIsAirCase(airstatus);
    setIsCCMCase(ccmStatus);

    if (stdstatus && acmdstatus && airstatus && ccmStatus) {
      Array.isArray(props.applicants) && props.applicants.length && props.applicants.map((applicant, index) => {
        if (applicant.nextActionId && applicant.nextActionId == 1) {
          // casewithmaintenance.push(applicant);
          casewithmaintenancecount = casewithmaintenancecount + 1;
        }
        else {
          // casewithoutmaintenance.push(applicant);
          casewithoutmaintenancecount = casewithoutmaintenancecount + 1;
        }
      })
    }
    else if (stdstatus) {
      Array.isArray(props.applicants) && props.applicants.length && props.applicants.map((applicant, index) => {
        if (CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus))) {
          if (applicant.nextActionId && applicant.nextActionId == 1) {
            // casewithmaintenance.push(applicant);
            casewithmaintenancecount = casewithmaintenancecount + 1;
          }
          else {
            // casewithoutmaintenance.push(applicant);
            casewithoutmaintenancecount = casewithoutmaintenancecount + 1;
          }
        }
      })
    }
    else if (ccmStatus) {
      Array.isArray(props.applicants) && props.applicants.length && props.applicants.map((applicant, index) => {
        if (CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus))) {
          if (applicant.nextActionId && applicant.nextActionId == 1) {
            // casewithmaintenance.push(applicant);
            casewithmaintenancecount = casewithmaintenancecount + 1;
          }
          else {
            // casewithoutmaintenance.push(applicant);
            casewithoutmaintenancecount = casewithoutmaintenancecount + 1;
          }
        }
      })
    }
    else if (acmdstatus) {
      Array.isArray(props.applicants) && props.applicants.length && props.applicants.map((applicant, index) => {
        if (CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus))) {
          if (applicant.nextActionId && applicant.nextActionId == 1) {
            // casewithmaintenance.push(applicant);
            casewithmaintenancecount = casewithmaintenancecount + 1;
          }
          else {
            // casewithoutmaintenance.push(applicant);
            casewithoutmaintenancecount = casewithoutmaintenancecount + 1;
          }
        }
      })
    }
    else {
      Array.isArray(props.applicants) && props.applicants.length && props.applicants.map((applicant, index) => {
        if (!CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus))) {
          if (applicant.nextActionId && applicant.nextActionId == 1) {
            // casewithmaintenance.push(applicant);
            casewithmaintenancecount = casewithmaintenancecount + 1;
          }
          else {
            // casewithoutmaintenance.push(applicant);
            casewithoutmaintenancecount = casewithoutmaintenancecount + 1;
          }

        }
      })
    }

    // setApplicantsWithMaintenance(casewithmaintenance);
    // setApplicantsWithoutMaintenance(casewithoutmaintenance);
    setCaseWithMaintenanceCount(casewithmaintenancecount);
    setCaseWithoutMaintenanceCount(casewithoutmaintenancecount);
  }

  const getStatusColorClass = (status) => {
    if (CASE_STATUS.isAccomodation(status) && isAcmdCase)
      return "bg-green";
    if (CASE_STATUS.isCCM(status) && isCCMCase)
      return "bg-green";
    if (CASE_STATUS.isStd(status) && isStdCase)
      return "bg-orange";
    else {
      if (isAirCase && !CASE_STATUS.isAccomodation(status) && !CASE_STATUS.isCCM(status) && !CASE_STATUS.isStd(status)) {
        return "bg-blue";
      }
      return;
    }
  }
  
  const handleChanges = (e) => {
    setSearchKeyword(e.target.value);
  }

  const onSearch = () => {
    props.getAllActiveCases(searchKeyword);
  }

  return (
    <>
      <div className="Dashboard-Content">
        <div className="row">
          <div className="back-btn-outer">
            <Backbutton />
            <div className="applicant-view-tab">
              <ul className="nav nav-pills">
                <li className="nav-item table-btn">
                  <a
                    onClick={() => onViewChange(false)}
                    className={
                      !grideView
                        ? "nav-link active table-btn"
                        : "nav-link table-btn"
                    }
                  >
                    {/* Table */}
                    {props.context.t("CURRENT_ACTIVITY.Table.text")}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    onClick={() => onViewChange(true)}
                    className={
                      grideView
                        ? "nav-link grid-btn active"
                        : "nav-link grid-btn"
                    }
                  >
                    {/* Grid */}
                    {props.context.t("CURRENT_ACTIVITY.Grid.text")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {grideView ? (
          <>
            <DisplayEmployeeName context={props.context} />
            {
              (props.einParam == null || props.einParam == "") &&
              <div class="row">
                <SearchComponent searchKeyword={searchKeyword} handleChanges={handleChanges} context={props.context} onSearch={onSearch} />
              </div>
            }
            <div className="row tab-btn">
              {(props.companyServices) && (props.companyServices.hasCCMFormFeatur || props.companyServices.hasSTDFormFeature || props.companyServices.hasAIRFormFeature || props.companyServices.hasACMDFormFeature) && <button className={(isStdCase && isAcmdCase && isAirCase && isCCMCase) ? "file-upload mt-0 btn btn-primary btn-tab active" : "file-upload mt-0 btn btn-primary btn-tab"} onClick={() => onStatusChange(true, true, true, true)}>{props.context.t("CurrentActivity.All.Text")}</button>}
              {(props.companyServices) && props.companyServices.hasSTDFormFeature && <button className={(isStdCase && !isAcmdCase && !isAirCase && !isCCMCase) ? "file-upload mt-0 btn btn-primary btn-tab active" : "file-upload mt-0 btn btn-primary btn-tab"} onClick={() => onStatusChange(true, false, false, false)}>{props.context.t("CurrentActivity.STD.Text")}</button>}
              {(props.companyServices) && props.companyServices.hasACMDFormFeature && <button className={(!isStdCase && isAcmdCase && !isAirCase && !isCCMCase) ? "file-upload mt-0 btn btn-primary btn-tab active" : "file-upload mt-0 btn btn-primary btn-tab"} onClick={() => onStatusChange(false, true, false, false)}>{props.context.t("CurrentActivity.ACCM.Text")}</button>}
              {(props.companyServices) && props.companyServices.hasAIRFormFeature && <button className={(!isStdCase && !isAcmdCase && isAirCase && !isCCMCase) ? "file-upload mt-0 btn btn-primary btn-tab active" : "file-upload mt-0 btn btn-primary btn-tab"} onClick={() => onStatusChange(false, false, true, false)}>{props.context.t("CurrentActivity.AIR.Text")}</button>}
              {(props.companyServices) && props.companyServices.hasCCMFormFeature && <button className={(!isStdCase && !isAcmdCase && !isAirCase && isCCMCase) ? "file-upload mt-0 btn btn-primary btn-tab active" : "file-upload mt-0 btn btn-primary btn-tab"} onClick={() => onStatusChange(false, false, false, true)}>{props.context.t("CurrentActivity.CCM.Text")}</button>}

            </div>
            {/* <div className="row">
            <label>Under Review</label>
            </div> */}
            <div className="row">
              {props.isRedirectCurrentActivityScreen ?
                <span className="ca-text">{caseWithMaintenanceCount + caseWithoutMaintenanceCount + props.context.t("CurrentActivity.ActiveCase.Text")}</span> :
                <span className="search-text">{props.context.t("EE.AllCaseDetailFor.Text")} {props.displayText}</span>
              }
              {/* <span className="ca-text">{caseWithMaintenanceCount > 0 ? "Under Review" : ""}</span> */}
              {/* <span className="ca-text">Under Review</span> */}
              {(isAirCase && isAcmdCase && isStdCase && isCCMCase) || (!isAirCase && isAcmdCase && !isStdCase && !isCCMCase) || (!isAirCase && !isAcmdCase && isStdCase && !isCCMCase) || (!isAirCase && !isAcmdCase && !isStdCase && isCCMCase) ? <span className="ca-text-for-ur">{caseWithMaintenanceCount > 0 ? props.context.t("CurrentActivity.UnderReview.Text") + "(" + caseWithMaintenanceCount + ")" : props.context.t("CurrentActivity.UnderReview.Text") + "(0)"}</span> : null}
              {Array.isArray(applicantsWithMaintenance) && applicantsWithMaintenance.length
                ? applicantsWithMaintenance.map((applicant, index) => (
                  <div
                    onClick={CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase ? () => openDetailModal(applicant) : CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isCCMCase ? () => openDetailModal(applicant) : CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isStdCase ? () => openDetailModal(applicant) : ((!CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAirCase)) ? () => openDetailModal(applicant) : null}
                    key={CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase ? `${applicant.ein}-${index}` : CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isCCMCase ? `${applicant.ein}-${index}` : CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isStdCase ? `${applicant.ein}-${index}` : ((!CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAirCase)) ? `${applicant.ein}-${index}` : null}
                    className={CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase ? "col-12 col-sm-12 col-md-12 col-lg-3 reset-pass" : CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isCCMCase ? "col-12 col-sm-12 col-md-12 col-lg-3 reset-pass" : CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isStdCase ? "col-12 col-sm-12 col-md-12 col-lg-3 reset-pass" : ((!CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAirCase)) ? "col-12 col-sm-12 col-md-12 col-lg-3 reset-pass" : null}
                  // key={`${applicant.ein}-${index}`}
                  // className="col-12 col-sm-12 col-md-12 col-lg-3 reset-pass"
                  >
                    {!applicant.isAIR && (CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase) || (CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isCCMCase) || (CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isStdCase) ?
                      <div className="s-box1">

                        <div className="srv-img">
                          <ul>
                            <li className={"box-title " + getStatusColorClass(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus))}>
                              <b>
                                {CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase
                                  ? (applicant.nextActionId && applicant.nextActionId == 1 ?
                                    <h5><b className="display-block">{props.context.t("CurrentActivity.ACCM.Text")}</b><small className="error-star"> {props.context.t("CurrentActivity.UnderReview1.Text")}</small></h5> : props.context.t("CurrentActivity.ACCM.Text")) :
                                  (CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus))) ?
                                    (applicant.nextActionId && applicant.nextActionId == 1 ?
                                      <h5><b className="display-block">{props.context.t("CurrentActivity.CCM.Text")}</b><small className="error-star"> {props.context.t("CurrentActivity.UnderReview1.Text")}</small></h5> : props.context.t("CurrentActivity.CCM.Text")) :
                                    (CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) ?
                                      (applicant.nextActionId && applicant.nextActionId == 1 ?
                                        <h5><b className="display-block">{props.context.t("CurrentActivity.STD.Text")}</b><small className="error-star"> {props.context.t("CurrentActivity.UnderReview1.Text")}</small></h5> : props.context.t("CurrentActivity.STD.Text")) :
                                      (applicant.nextActionId && applicant.nextActionId == 1 ?
                                        <h5><b className="display-block">{props.context.t("CurrentActivity.AIR.Text")}</b><small className="error-star"> {props.context.t("CurrentActivity.UnderReview1.Text")}</small></h5> : props.context.t("CurrentActivity.AIR.Text"))
                                    )
                                }
                              </b>
                            </li>
                            {props.isRedirectCurrentActivityScreen ?
                              <li className={"box-header-title"}>
                                <b>{applicant.firstName + " " + applicant.lastName}</b>
                              </li> : null}
                            <div className="row box-detail">
                              <div className="col-md-12">
                                {
                                  CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase ?
                                    <div>
                                      <li>
                                        {props.context.t("CurrentActivity.DateOpened.Text")}:
                                        {applicant.firstDayAbsentFromWork
                                          ? utilities.formatDate(
                                            applicant.firstDayAbsentFromWork,
                                            "MMM DD YYYY"
                                          )
                                          : "-"}
                                      </li>
                                      {!props.isRedirectCurrentActivityScreen && <li className="m-0">
                                        {props.context.t("CurrentActivity.DateClosed.Text")}:
                                        {applicant.dateClosed
                                          ? utilities.formatDate(
                                            applicant.dateClosed,
                                            "MMM DD YYYY"
                                          )
                                          : "-"}
                                      </li>}
                                    </div> :
                                    CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isCCMCase ?
                                      <div>
                                        <li>
                                          {props.context.t("CurrentActivity.DateOpened.Text")}:
                                          {applicant.firstDayAbsentFromWork
                                            ? utilities.formatDate(
                                              applicant.firstDayAbsentFromWork,
                                              "MMM DD YYYY"
                                            )
                                            : "-"}
                                        </li>
                                        {!props.isRedirectCurrentActivityScreen && <li className="m-0">
                                          {props.context.t("CurrentActivity.DateClosed.Text")}:
                                          {applicant.dateClosed
                                            ? utilities.formatDate(
                                              applicant.dateClosed,
                                              "MMM DD YYYY"
                                            )
                                            : "-"}
                                        </li>}
                                      </div>

                                      :
                                      CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isStdCase &&
                                      <div>
                                        <li>
                                          {props.context.t("CurrentActivity.FdaDate.Text")}:
                                          {applicant.firstDayAbsentFromWork
                                            ? utilities.formatDate(
                                              applicant.firstDayAbsentFromWork,
                                              "MMM DD YYYY"
                                            )
                                            : "-"}
                                        </li>
                                        {props.isRedirectCurrentActivityScreen ? <><li className="m-0">
                                          {props.context.t("CurrentActivity.CurrentStatus.Text")}:
                                          {applicant.caseStatus ? applicant.caseStatus : "-"}
                                        </li>
                                          <li>
                                            {props.context.t("CurrentActivity.xrtwDate.Text")}:
                                            {applicant.xRTW
                                              ? utilities.formatDate(
                                                applicant.xRTW,
                                                "MMM DD YYYY"
                                              )
                                              : "-"}
                                          </li></> :
                                          <li>
                                            {props.context.t("CurrentActivity.DateClosed.Text")}:
                                            {applicant.dateClosed
                                              ? utilities.formatDate(
                                                applicant.dateClosed,
                                                "MMM DD YYYY"
                                              )
                                              : "-"}
                                          </li>
                                        }
                                      </div>}

                              </div>

                              <div className="col-md-12">
                                {
                                  applicant.isForBackup &&
                                  <strong className="float-right badge badge-success">Backup</strong>
                                }
                              </div>
                            </div>
                          </ul>
                        </div>
                      </div>
                      :
                      isAirCase && !CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && <div className="s-box1">
                        <div className="srv-img">
                          <ul>
                            <li className={"box-title bg-blue"}>
                              <b>{props.context.t("CurrentActivity.AIR.Text")}</b>
                            </li>
                            {props.isRedirectCurrentActivityScreen ?
                              <li className={"box-header-title"}>
                                <b>{applicant.firstName + " " + applicant.lastName}</b>
                              </li> : null}
                            <div className="row box-detail">
                              {isAirCase &&
                                <div className="col-md-12">
                                  {props.isRedirectCurrentActivityScreen && <li>
                                    {props.context.t("CurrentActivity.airDate.Text")}:
                                    {applicant.dateAIRSubmitted
                                      ? utilities.formatDate(
                                        applicant.dateAIRSubmitted,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </li>}
                                  <li>
                                    {props.context.t("CurrentActivity.accidentDate.Text")}:
                                    {applicant.dateOfIncident
                                      ? utilities.formatDate(
                                        applicant.dateOfIncident,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </li>
                                  <li>
                                    {props.context.t("CurrentActivity.rtwDate.Text")}:
                                    {applicant.dateEmployeeReturnedToWork
                                      ? utilities.formatDate(
                                        applicant.dateEmployeeReturnedToWork,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </li>
                                </div>}

                              <div className="col-md-12">
                                {
                                  applicant.isForBackup &&
                                  <strong className="float-right badge badge-success">Backup</strong>
                                }
                              </div>
                              <div className="col-md-12">

                                {/* <li className="m-0">
                                Date Closed:
                                {applicant.dateClosed
                                  ? utilities.formatDate(
                                    applicant.dateClosed,
                                    "MMM DD YYYY"
                                  )
                                  : "-"}
                              
                              </li> */}
                              </div>
                            </div>
                          </ul>
                        </div>
                      </div>
                    }
                  </div>
                ))
                : null}
              {/* second */}
            </div>
            {/* second row */}
            <div className="row">
              {/* <button className="file-upload mt-0 btn btn-primary" onClick={() => onStatusChange(true, true, true)}>All</button>
              <button className="file-upload mt-0 btn btn-primary margin-left-15" onClick={() => onStatusChange(true, false, false)}>Short-term Disability</button>
              <button className="file-upload mt-0 btn btn-primary margin-left-15" onClick={() => onStatusChange(false, true, false)}>Accomodation</button>
              <button className="file-upload mt-0 btn btn-primary margin-left-15" onClick={() => onStatusChange(false, false, true)}>Workers Compensation</button> */}

              {/* {props.isRedirectCurrentActivityScreen ?
                <span className="ca-text">{props.displayText}</span> :
                <span className="search-text">{props.displayText}</span>
              } */}
              {/* second */}
              {/* <span className="ca-text">{caseWithoutMaintenanceCount > 0 ? "All Cases" : ""}</span> */}
              {/* <span className="ca-text">All Cases</span>
              <span className="ca-text">{caseWithoutMaintenanceCount > 0 ? "" : "No cases"}</span> */}
              {Array.isArray(applicantsWithoutMaintenance) && applicantsWithoutMaintenance.length
                ? applicantsWithoutMaintenance.map((applicant, index) => (
                  <div
                    onClick={CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase ? () => openDetailModal(applicant) : CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isCCMCase ? () => openDetailModal(applicant) : CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isStdCase ? () => openDetailModal(applicant) : ((!CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAirCase)) ? () => openDetailModal(applicant) : null}
                    key={CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase ? `${applicant.ein}-${index}` : CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isCCMCase ? `${applicant.ein}-${index}` : CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isStdCase ? `${applicant.ein}-${index}` : ((!CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAirCase)) ? `${applicant.ein}-${index}` : null}
                    className={CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase ? "col-12 col-sm-12 col-md-12 col-lg-3 reset-pass" : CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isCCMCase ? "col-12 col-sm-12 col-md-12 col-lg-3 reset-pass" : CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isStdCase ? "col-12 col-sm-12 col-md-12 col-lg-3 reset-pass" : ((!CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && !CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAirCase)) ? "col-12 col-sm-12 col-md-12 col-lg-3 reset-pass" : null}
                  // key={`${applicant.ein}-${index}`}
                  // className="col-12 col-sm-12 col-md-12 col-lg-3 reset-pass"
                  >
                    {!applicant.isAIR && (CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase) || (CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isStdCase) || (CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isCCMCase) ?
                      <div className="s-box1">
                        <div className="srv-img">
                          <ul>
                            <li className={"box-title " + getStatusColorClass(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus))}>
                              <b>
                                {CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase
                                  ? (applicant.nextActionId && applicant.nextActionId == 1 ?
                                    <h5><b className="display-block">{props.context.t("CurrentActivity.ACCM.Text")}</b><small className="error-star"> {props.context.t("CurrentActivity.UnderReview1.Text")}</small></h5> : props.context.t("CurrentActivity.ACCM.Text")) :
                                  (CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) ?
                                    (applicant.nextActionId && applicant.nextActionId == 1 ?
                                      <h5><b className="display-block">{props.context.t("CurrentActivity.STD.Text")}</b><small className="error-star"> {props.context.t("CurrentActivity.UnderReview1.Text")}</small></h5> : props.context.t("CurrentActivity.STD.Text")) :
                                    CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) ?
                                      (applicant.nextActionId && applicant.nextActionId == 1 ?
                                        <h5><b className="display-block">{props.context.t("CurrentActivity.CCM.Text")}</b><small className="error-star"> {props.context.t("CurrentActivity.UnderReview1.Text")}</small></h5> : props.context.t("CurrentActivity.CCM.Text")) :
                                      (applicant.nextActionId && applicant.nextActionId == 1 ?
                                        <h5><b className="display-block">{props.context.t("CurrentActivity.AIR.Text")}</b><small className="error-star"> {props.context.t("CurrentActivity.UnderReview1.Text")}</small></h5> : props.context.t("CurrentActivity.AIR.Text"))
                                  )
                                }
                              </b>
                            </li>
                            {props.isRedirectCurrentActivityScreen ?
                              <li className={"box-header-title"}>
                                <b>{applicant.firstName + " " + applicant.lastName}</b>
                              </li> : null}
                            <div className="row box-detail">
                              <div className="col-md-12">
                                {CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isAcmdCase ?
                                  <div>
                                    <li>
                                      {props.context.t("CurrentActivity.DateOpened.Text")}:
                                      {applicant.dateCaseOpened
                                        ? utilities.formatDate(
                                          applicant.dateCaseOpened,
                                          "MMM DD YYYY"
                                        )
                                        : "-"}
                                    </li>
                                    {!props.isRedirectCurrentActivityScreen && <li className="m-0">
                                      {props.context.t("CurrentActivity.DateClosed.Text")}:
                                      {applicant.dateClosed
                                        ? utilities.formatDate(
                                          applicant.dateClosed,
                                          "MMM DD YYYY"
                                        )
                                        : "-"}
                                    </li>}
                                  </div> :
                                  CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isCCMCase ?
                                    <div>
                                      <li>
                                        {props.context.t("CurrentActivity.DateOpened.Text")}:
                                        {applicant.dateCaseOpened
                                          ? utilities.formatDate(
                                            applicant.dateCaseOpened,
                                            "MMM DD YYYY"
                                          )
                                          : "-"}
                                      </li>
                                      {!props.isRedirectCurrentActivityScreen && <li className="m-0">
                                        {props.context.t("CurrentActivity.DateClosed.Text")}:
                                        {applicant.dateClosed
                                          ? utilities.formatDate(
                                            applicant.dateClosed,
                                            "MMM DD YYYY"
                                          )
                                          : "-"}
                                      </li>}
                                    </div>
                                    :
                                    CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && isStdCase &&
                                    <div>
                                      <li>
                                        {props.context.t("CurrentActivity.FdaDate.Text")}:
                                        {applicant.dateCaseOpened
                                          ? utilities.formatDate(
                                            applicant.dateCaseOpened,
                                            "MMM DD YYYY"
                                          )
                                          : "-"}
                                      </li>
                                      {props.isRedirectCurrentActivityScreen ? <><li className="m-0">
                                        {props.context.t("CurrentActivity.CurrentStatus.Text")}:
                                        {applicant.caseStatus ? applicant.caseStatus : "-"}
                                      </li>
                                        <li>
                                          {props.context.t("CurrentActivity.xrtwDate.Text")}:
                                          {applicant.xRTW
                                            ? utilities.formatDate(
                                              applicant.xRTW,
                                              "MMM DD YYYY"
                                            )
                                            : "-"}
                                        </li></> :
                                        <li>
                                          {props.context.t("CurrentActivity.DateClosed.Text")}:
                                          {applicant.dateClosed
                                            ? utilities.formatDate(
                                              applicant.dateClosed,
                                              "MMM DD YYYY"
                                            )
                                            : "-"}
                                        </li>
                                      }
                                    </div>}

                              </div>

                              <div className="col-md-12">
                                {
                                  applicant.isForBackup &&
                                  <strong className="float-right badge badge-success">Backup</strong>
                                }
                              </div>
                            </div>
                          </ul>
                        </div>
                      </div>
                      :
                      isAirCase && !CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus))
                      && !CASE_STATUS.isStd(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus))
                      && !CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(applicant.fileStatusInformation, applicant.fileStatus)) && <div className="s-box1">
                        <div className="srv-img">
                          <ul>
                            <li className={"box-title bg-blue"}>
                              <b>{props.context.t("CurrentActivity.AIR.Text")}</b>
                            </li>
                            {props.isRedirectCurrentActivityScreen ?
                              <li className={"box-header-title"}>
                                <b>{applicant.firstName + " " + applicant.lastName}</b>
                              </li> : null}
                            <div className="row box-detail">
                              {isAirCase &&
                                <div className="col-md-12">
                                  {props.isRedirectCurrentActivityScreen && <li>
                                    {props.context.t("CurrentActivity.airDate.Text")}:
                                    {applicant.dateAIRSubmitted
                                      ? utilities.formatDate(
                                        applicant.dateAIRSubmitted,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </li>}
                                  <li>
                                    {props.context.t("CurrentActivity.accidentDate.Text")}:
                                    {applicant.dateOfIncident
                                      ? utilities.formatDate(
                                        applicant.dateOfIncident,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </li>
                                  <li>
                                    {props.context.t("CurrentActivity.rtwDate.Text")}:
                                    {applicant.dateEmployeeReturnedToWork
                                      ? utilities.formatDate(
                                        applicant.dateEmployeeReturnedToWork,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </li>
                                </div>}

                              <div className="col-md-12">
                                {
                                  applicant.isForBackup &&
                                  <strong className="float-right badge badge-success">Backup</strong>
                                }
                              </div>
                              <div className="col-md-12">

                                {/* <li className="m-0">
                                Date Closed:
                                {applicant.dateClosed
                                  ? utilities.formatDate(
                                    applicant.dateClosed,
                                    "MMM DD YYYY"
                                  )
                                  : "-"}
                              
                              </li> */}
                              </div>
                            </div>
                          </ul>
                        </div>
                      </div>
                    }

                    {/* second */}
                  </div>
                ))
                : null}
            </div>
          </>
        ) : (
          <>
            <DisplayEmployeeName context={props.context} />
            {
              (props.einParam == null || props.einParam == "") &&
              <div class="row">
                <SearchComponent searchKeyword={searchKeyword} handleChanges={handleChanges} context={props.context} onSearch={onSearch} />
              </div>
            }
            <span className="search-text">{props.displayText}</span>
            <br />
            <StdAcmdCaseDetailsTableComponent
              isRedirectCurrentActivityScreen={props.isRedirectCurrentActivityScreen}
              einParam={props.einParam}
              applicants={props.applicants}
              getStatusColorClass={getStatusColorClass}
              onCaseDownload={props.onCaseDownload}
              onAllCaseDownload={props.onAllCaseDownload}
              context={props.context}
              selectedLanguage={props.selectedLanguage}
              addRow={addRow} />

            <AirCaseDetailTableComponent
              isRedirectCurrentActivityScreen={props.isRedirectCurrentActivityScreen}
              einParam={props.einParam}
              applicants={props.applicants}
              onCaseDownload={props.onCaseDownload}
              context={props.context}
              onAllCaseDownload={props.onAllCaseDownload}
              selectedLanguage={props.selectedLanguage}
              addRow={addRow} />
          </>
        )}
      </div>
    </>
  );
};

AllCaseDetailsComponent.defaultProps = {
  isRedirectCurrentActivityScreen: false
}

export default AllCaseDetailsComponent;
